import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { translate } from "../../../../base/i18n/functions";
import Dialog from "../../../../base/ui/components/web/Dialog";
/**
 * React Component for getting confirmation to stop a file recording session in
 * progress.
 *
 * @augments Component
 */
class StopRecordingDialogElectron extends PureComponent {
    /**
     * Initializes a new DesktopPicker instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        // Bind event handlers so they are only bound once per instance.
        this._onSubmit = this._onSubmit.bind(this);
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { t } = this.props;
        return (React.createElement(Dialog, { ok: { translationKey: "dialog.confirm" }, onSubmit: this._onSubmit, titleKey: "dialog.recording" }, t("dialog.stopRecordingWarning")));
    }
    _onSubmit() {
        this.props.onConfirm();
    }
}
export default translate(connect()(StopRecordingDialogElectron));
